<template>
  <div id="knowledge">
    <bread :content="breadContent"></bread>
    <p class="Page-title">应急常识</p>
    <el-divider></el-divider>
    <div id="content">
      <klg-item v-for="(item,index) in tableData" :key="index" :id="item.Id" :Title="item.Title" :AdminSetTime="item.AdminSetTime"></klg-item>
    </div>
    <el-pagination class="page" background layout="prev, pager, next,jumper" :total="itemData.length" :page-size="9" @current-change="handleCurrentChange" :current-page="tableIndex">
    </el-pagination>
  </div>
</template>
<script>
import bread from "@/components/bread";
import klgItem from "@/components/emrclass/klgItem";
import Api from "@/network.js";
export default {
  name: "knowledge",
  components: {
    bread,
    klgItem
  },
  async beforeRouteEnter(to, from, next) {
    let res = (await Api.emrClass.getKnowledge()) || [];
    next(vm => {
      vm.itemData = res;
      vm.tableData = res.slice(0, 9);
    });
  },
  data() {
    return {
      breadContent: [
        { text: "应急课堂", routerName: "emrClass" },
        { text: "应急常识", routerName: "emrClass" }
      ],
      tableData: [],
      itemData: [],
      tableIndex: 1
    };
  },
  methods: {
    handleCurrentChange(index) {
      this.tableData = this.itemData.slice((index - 1) * 9, index * 9);
    }
  }
};
</script>
  
<style lang="scss" scoped>
#knowledge {
  display: block;
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
}
#content {
  width: 90%;
  margin: 0 auto;
}
.klgItem {
  padding: 22px 0;
  border-bottom: 1px rgb(189, 189, 189) dotted;
}
.page {
  width: 100%;
  transform: scale(1.3);
  text-align: center;
  margin-top: 50px;
}
</style>


